module.exports = __webpack_public_path__ + "static/media/fm.cfc37567.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fm.svg
// module id = 114
// module chunks = 0